// Staging environment.
export const environment = {
  production: true,
  apiUrl: 'https://dmstest.cm.idrapi.forthrightsolutions.com/api',
  brokerAuthority: 'https://dmstest.identitybroker.forthrightsolutions.com',
  // Client-side upload hint only. The server is authoritative — IDR.ExternalApi enforces
  // DocumentStorage:MaxFileBytes, and IIS enforces its own requestLimits before that. Keep this in
  // step with those by hand; there is no config endpoint to read it from.
  maxDocumentBytes: 268435456,
  reviewMode: false,
  paymentRedirectEnabled: true,
  paymentRedirectUrl: null as string | null,
};
